export default __webpack_public_path__ + "static/media/step4DarkMode.3cb850ca.svg";